define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi/table/matrix/Path"
], function(array,declare,PathMatrix) {

	return declare(PathMatrix, {
		restrictQuery: true,

		_filterNodes: function(/*Context*/ctx, /*Spec*/spec, /*Node[]*/nodes) {
			var reports = array.filter(nodes, function(node) {
				return node.$Type == "CrewAssignmentReport";
			});

			reports.sort(function(r1, r2) {
				if (!r1) return (!r2 ? 0 : -1);
				if (!r2) return 1;

				var diff = r1.CrewDistance - r2.CrewDistance;
				if (diff != 0) return diff;

				return ctx.cache.getNode(r1.User).$Name.localeCompare(ctx.cache.getNode(r2.User).$Name);
			});

			return reports;
		}
	});
});